export const businessTypes = {
  Trucking: {
    income: ["Freight Income", "Lease Income", "Fuel Surcharge Revenue"],
    expenses: [
      "Fuel Expense",
      "Truck Repairs and Maintenance",
      "Driver Salaries/Wages",
      "Insurance Premiums",
      "Toll Charges",
      "Loan Payment",
      "Accounts Payable",
    ],
    payables: [
      "Provider Payments (Expense) / Money Owed to Suppliers (Expense)",
      "Freight Costs (Expense)",
      "Wages (Expense)",
      "Utilities (Expense)",
      "Taxes (Expense)",
      "Rent (Expense)",
      "Insurance (Expense)",
    ],
  },
  "RIDESHARE DRIVERS/PARTNERS": {
    income: [
      "Fare from Passengers",
      "Bonuses and Incentives",
      "Uber Eats or Lyft Delivery",
    ],
    expenses: [
      "Vehicle Maintenance & Repairs",
      "Fuel",
      "Car Insurance",
      "Vehicle Depreciation",
      "Rideshare Fees",
      "Taxes",
      "Loan Payments (if applicable)",
      "Miscellaneous",
    ],
    payables: [
      "Provider Payments (Expense) / Money Owed to Suppliers (Expense)",
      "Fuel Costs (Expense)",
      "Vehicle Maintenance (Expense)",
      "Insurance (Expense)",
      "Oil Changes (Expense)",
      "Taxes (Expense)",
      "Rent (Expense)",
      "Miscellaneous (Expense)",
    ],
  },
  "Individual/Households": {
    income: [
      "Salary/Wages",
      "Bonuses/Commissions",
      "Self-Employment/Side Hustles",
      "Investment Income",
      "Rental Income",
      "Government Assistance",
      "Pension or Retirement Funds",
      "Alimony/Child Support",
      "Other Income",
    ],
    expenses: [
      "Housing",
      "Transportation",
      "Food & Groceries",
      "Healthcare",
      "Debt Payments",
      "Savings & Investments",
      "Entertainment & Leisure",
      "Childcare & Education",
      "Insurance",
      "Taxes",
      "Miscellaneous",
    ],
    payables: [
      "Bills (Expense)",
      "Rent (Expense)",
      "Utilities (Expense)",
      "Insurance (Expense)",
      "Taxes (Expense)",
      "Debt Payments (Expense)",
      "Miscellaneous (Expense)",
    ],
  },
  Groceries: {
    income: ["Gross Sales", "Delivery Fees", "Rental Income", "Service Fees"],
    expenses: [
      "Cost of Goods Sold (COGS)",
      "Labor Costs",
      "Rent/Lease",
      "Utilities",
      "Insurance",
      "Marketing and Advertising",
      "Supplies",
      "Maintenance and Repairs",
      "Licensing and Permits",
      "Shipping and Delivery",
      "Depreciation",
      "Bank Fees and Interest",
      "Professional Services",
      "Miscellaneous Expenses",
    ],
    payables: [
      "Provider Payments (Expense) / Money Owed to Suppliers (Expense)",
      "Inventory Purchases (Expense)",
      "Inventory Adjustments (Expense)",
      "Utilities (Expense)",
      "Insurance (Expense)",
      "Rent (Expense)",
      "Miscellaneous (Expense)",
    ],
    boughtNewItemPurposes: [
      "Inventory Purchases",
      "Inventory Adjustments",
    ],
  },
  Cafe: {
    income: [
      "Food Sales",
      "Beverage Sales",
      "Dessert Sales",
      "Takeout or Delivery Sales",
      "Catering or Event Revenue",
      "Gift Cards or Vouchers",
      "Other Income",
    ],
    expenses: [
      "Food Costs",
      "Beverage Costs",
      "Packaging",
      "Supplies for Preparing Food",
      "Labor Costs",
      "Rent or Lease",
      "Utilities",
      "Insurance",
      "Marketing and Advertising",
      "Cleaning and Maintenance",
      "Licenses and Permits",
      "Professional Fees",
      "Equipment and Supplies",
      "Credit Card Fees",
      "Delivery Costs",
      "Depreciation",
      "Interest",
      "Bad Debt",
      "Bank Fees",
      "Miscellaneous",
    ],
    payables: [
      "Provider Payments (Expense) / Money Owed to Suppliers (Expense)",
      "Food Costs (Expense)",
      "Beverage Costs (Expense)",
      "Rent (Expense)",
      "Utilities (Expense)",
      "Insurance (Expense)",
      "Miscellaneous (Expense)",
    ],
  },
  "Cleaning Services": {
    income: [
      "Recurring Residential Cleaning Contracts",
      "One-Time Deep Cleaning Services",
      "Move-In/Move-Out Cleans",
      "Commercial Office Cleaning Contracts",
      "Airbnb Turnover Services",
    ],
    expenses: [
      "Cleaning Supplies (disinfectants, mops, vacuums)",
      "Employee Wages",
      "Fuel and Transportation",
      "Uniforms",
      "Advertising (flyers, Google/local ads)",
      "Equipment Maintenance and Replacements",
      "Liability Insurance",
    ],
    payables: [
      "Supplies (Expense)",
      "Wages (Expense)",
      "Fuel (Expense)",
      "Insurance (Expense)",
      "Advertising (Expense)",
      "Uniforms (Expense)",
      "Equipment Maintenance (Expense)",
    ],
  },
  "⁠Beauty & Grooming": {
    income: [
      "Haircuts and Hairstyling",
      "Hair Coloring and Treatments",
      "Beard Trims and Shaving",
      "Manicures and Pedicures",
      "Product Retail l (shampoos, conditioners, gels)",
      "Special Packages (weddings, events)",
    ],
    expenses: [
      "Hair & Beauty Products",
      "Tools and Equipment (clippers, scissors, dryers)",
      "Rent and Utilities",
      "Employee Wages or Booth Rentals",
      "Salon Software (scheduling, POS)",
      "Sterilization Supplies (barbicide, gloves)",
      "Towels and Laundry Service",
      "Business Licenses and Inspections",
    ],
    payables: [
      "Product Supplies (Expense)",
      "Rent (Expense)",
      "Utilities (Expense)",
      "Wages (Expense)",
      "Software Subscriptions (Expense)",
      "Licenses (Expense)",
      "Laundry and Cleaning (Expense)",
    ],
  },
  "E-commerce Sellers": {
    income: [
      "Online Product Sales",
      "Bulk/Wholesale Orders",
      "Custom Orders",
      "Subscription Boxes",
      "Affiliate Income",
      "Digital Product Sales  (eBooks, downloads)",
    ],
    expenses: [
      "Product Sourcing and Inventory",
      "Packaging and Shipping Materials",
      "Platform Fees (Shopify, Amazon seller fees)",
      "Payment Transaction Fees",
      "Online Advertising (Meta, Google, SEO)",
      "Web Hosting/Domain",
      "Software Subscriptions (Canva, QuickBooks)",
      "Warehouse or Storage Rental",
    ],
    payables: [
      "Inventory Purchases (Expense)",
      "Shipping Materials (Expense)",
      "Advertising (Expense)",
      "Software/Platform Fees (Expense)",
      "Warehouse Rent (Expense)",
    ],
    boughtNewItemPurposes: [
      "Inventory Purchases",
      "Shipping Materials",
    ],
  },
  "Construction Trades": {
    income: [
      "Service Calls and Labor Fees",
      "Repair and Installation Jobs",
      "Home Remodeling and Renovation Contracts",
      "Emergency Call-Outs",
      "Subcontracting Projects",
      "Consulting and Design Services",
    ],
    expenses: [
      "Tools and Equipment (drills, ladders, PPE)",
      "Construction Materials (pipes, wiring, paint)",
      "Subcontractor Wages",
      "Vehicle Fuel and Maintenance",
      "Business and Liability Insurance",
      "Licensing and Permits",
      "Job Site Safety Training",
    ],
    payables: [
      "Tools & Materials (Expense)",
      "Subcontractor Payments (Expense)",
      "Fuel (Expense)",
      "Insurance (Expense)",
      "Permits (Expense)",
      "Training Costs (Expense)",
    ],
  },
  "Content Creator": {
    income: [
      "Ad revenue (YouTube, Facebook, etc.)",
      "Sponsorship deals",
      "Affiliate commissions",
      "Merchandise sales",
      "Digital product sales (e.g. presets, courses)",
      "Client work (if applicable)",
      "Tips or donations (e.g. Patreon, Ko-fi)",
    ],
    expenses: [
      "Equipment purchases or rentals (cameras, mics, lights)",
      "Software subscriptions (editing tools, cloud storage)",
      "Internet and utilities",
      "Office or studio rent",
      "Marketing and promotion",
      "Travel and lodging (for content shoots)",
      "Contractors or freelancers (editors, thumbnail designers)",
    ],
    payables: [
      "Outstanding invoices to vendors",
      "Scheduled payments to freelancers or agencies",
      "Equipment leases",
    ],
    receivables: [
      "Unpaid brand deals or invoices",
      "Late payments from platforms or affiliates",
    ],
  },

  Other: {
    income: [], // Manual entry
    expenses: [], // Manual entry
    payables: [], // Manual entry
  },
};
